import { useTranslation } from 'react-i18next';

import { EmptyState } from '@/ui-kit/templates/EmptyState/EmptyState';

import { IUser, UserTypes } from '@/features/user/store/user.model';

import { AddWallet } from '@/features/wallets/components/AddWallet/AddWallet';

interface IWalletCreationProps {
  user: IUser;
}

export const WalletCreation = ({ user }: IWalletCreationProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center w-full h-[40vh]">
      <EmptyState
        icon="wallet_v1"
        size="l"
        title={t(
          `pages.currentProfiles.wallets.noWallet.${user.userTypeId === UserTypes.naturalPerson ? 'physicalTitle' : 'legalTitle'}`,
        )}
        state={t(`pages.currentProfiles.wallets.noWallet.description`)}
      />
      <AddWallet user={user} />
    </div>
  );
};
